export default {"src":"/_next/static/image/public/images/flags/flag_47.e181f76406ee8264f7945c347f4f2fee.svg","height":16,"width":24};